/**
 * DTO object for creation of Review Response.
 */
export class ResponseDto {
  id: number;
  reviewId: number;
  responseId: number;
  name: string;
  content: string;
  createdDateAt: Date;
}
